import { render, staticRenderFns } from "./StockOperationPage.vue?vue&type=template&id=4c95943d&scoped=true"
import script from "./StockOperationPage.vue?vue&type=script&lang=js"
export * from "./StockOperationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c95943d",
  null
  
)

export default component.exports